<template>
  <ReleaseModuleWrapper
    :bgcolor="color"
    :class="touchState ? 'module-tapped' : 'not-tapped'"
  >
    <LinkButton v-if="Data.link" :Color="color" :Link="Data.link ? Data.link : ''"/>
    <TitleBlock :TitleCopy="Data.title" :Color="color" :TitleClass="'release-title'"/>
    <div class="image-wrapper">
      <div class="image">
        <LazyImg :src="Data.image ? Data.image : Data.pack_shot.large"/>
      </div>
    </div>
  </ReleaseModuleWrapper>
</template>

<script>
import styled from 'vue-styled-components'
import Color from 'color'
import { colors, spacing } from '@/styles/theme'
import * as _ from '@/styles/mixins'
import randomArrItem from '@/scripts/randomArrItem'
import LazyImg from '@/components/LazyImg'
import TitleBlock from './TitleBlock'
import LinkButton from './LinkButton'

// STYLES
const props = {
  bgcolor: String
}

const ReleaseModuleWrapper = styled('div', props)`
  ${_.absoluteTopFull};
  overflow: hidden;
  background-color: ${props => props.bgcolor};
  .image-wrapper {
    ${_.absoluteTopFull};
    padding: ${spacing.thumb_pad};
    z-index: 0;
  }
  h4 {
    ${_.absoluteCentered};
    width: 150vw;
    left: -25vw;
    padding: 0 4vw;
    ${_.media.desktop`
      width: 80vw;
      left: -15vw!important;
      padding: 0 17vw;
    `}
  }
  .image {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 0 0px ${props => Color(props.bgcolor).rotate(0)});
    transform: rotate(0deg);
    transition: filter 500ms ease-in-out, transform 50ms ease;
    will-change: filter, transform;
    z-index: 10;
    pointer-events: none;
  }
  &.module-tapped {
    .title {
      opacity: 1;
      h4 {
        filter: drop-shadow(0 0 30px ${props => Color(props.bgcolor).rotate(180)});
        transform: scale(1);
      }
    }
    .link-button {
      transform: translateX(0);
    }
    .image {
      filter: drop-shadow(0 0 25px ${props => Color(props.bgcolor).rotate(-90)});
      transform: rotate(-1deg);
    }
  }
  ${_.media.hover`
    &:hover {
      .title {
        opacity: 1;
        h4 {
          filter: drop-shadow(0 0 80px ${props => Color(props.bgcolor).rotate(180)});
          transform: scale(1);
        }
      }
      .link-button {
        transform: translateX(0);
      }
      .image {
        filter: drop-shadow(0 0 50px ${props => Color(props.bgcolor).rotate(-90)});
        transform: rotate(-2deg);
      }
    }
  `}
`

// VUE
export default {
  props: [
    'Data',
    'touchState'
  ],
  components: {
    ReleaseModuleWrapper,
    LazyImg,
    TitleBlock,
    LinkButton
  },
  data () {
    return {
      color: randomArrItem(colors.fc)
    }
  }
}
</script>
